module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "multiSelectPicker"
  }, [_c('overlay-anchor', {
    attrs: {
      "anchor": _vm.anchor,
      "directions": _vm.directions
    },
    on: {
      "positioned": _vm.updatePosition
    }
  }, [_c('div', {
    staticClass: "overlay",
    style: ({
      'max-width': (_vm.windowDimmensions.width - _vm.position.x - 5) + 'px',
      'max-height': (_vm.windowDimmensions.height - _vm.position.y - 5) + 'px'
    })
  }, [_c('ul', {}, _vm._l((_vm.visibleOptions), function(option, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.set(option)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.display(option)))])])
  }))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d5c3520","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/SingleSelectPicker.vue
// module id = 420
// module chunks = 1